import { useEffect, useState } from "react";
import { api } from "../api";
import { Link } from "../router";

const ICON: Record<string, string> = { registration: "Registered", appointment: "Visit", consultation: "Consultation", prescription: "Prescription", order: "Order",
  certificate: "Certificate", allergy: "Allergy", consent: "Consent", message: "Message", vitals: "Vitals", lab: "Lab" };

/** The longitudinal record on the patient's page. Clinical entries appear only for clinicians. */
export function PatientTimeline({ patientId }: { patientId: string }) {
  const [d, setD] = useState<{ items: any[]; includesClinical: boolean } | null>(null);
  const [allergies, setAllergies] = useState<any[] | null>(null);
  const [filter, setFilter] = useState("all");
  useEffect(() => {
    api.authed(`/api/v1/patients/${patientId}/timeline`).then(setD).catch(() => {});
    api.authed(`/api/v1/patients/${patientId}/clinical-summary`).then((r) => setAllergies([...r.allergies.filter((a: any) => a.status === "active"), ...r.problems.filter((p: any) => p.status === "active")])).catch(() => setAllergies(null));
  }, [patientId]);
  if (!d) return null;
  const kinds = [...new Set(d.items.map((x) => x.kind))];
  const shown = d.items.filter((x) => filter === "all" || x.kind === filter);
  const when = (iso: string) => new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  return (
    <>
      {allergies && <section aria-labelledby="pc-h"><h2 id="pc-h">Allergies and conditions</h2>
        {allergies.length ? <ul className="chips">{allergies.map((a) => <li key={a.id} className={a.kind === "allergy" ? "chip-alert" : ""}>{a.kind === "allergy" ? `Allergic: ${a.substance}` : a.kind === "nkda" ? "No known drug allergies" : a.label}</li>)}</ul>
          : <p className="muted">Nothing recorded.</p>}
      </section>}
      <section aria-labelledby="tl-h">
        <div className="page-head"><h2 id="tl-h">Timeline</h2>
          <label className="sr-only" htmlFor="tl-f">Show</label>
          <select id="tl-f" className="inline-select" value={filter} onChange={(e) => setFilter(e.target.value)}><option value="all">Everything</option>{kinds.map((k) => <option key={k} value={k}>{ICON[k]}</option>)}</select>
        </div>
        {!d.includesClinical && <p className="muted small">Clinical details are visible to clinicians only.</p>}
        <ol className="timeline">{shown.map((e, i) => (
          <li key={i} className={`tl tl-${e.kind}`}>
            <span className="tl-when">{when(e.at)}</span>
            <span className="tl-kind">{ICON[e.kind]}</span>
            <span className="tl-what">{e.ref?.type === "encounter" ? <Link to={`/app/consultations/${e.ref.id}`}>{e.title}</Link> : e.ref?.type === "lab_request" ? <Link to={`/app/lab/${e.ref.id}`}>{e.title}</Link> : e.title}{e.detail && <span className="muted"> · {e.detail}</span>}</span>
          </li>))}
        </ol>
      </section>
    </>
  );
}
